<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">MEMBER</p>
        <p class="topic_cht">參展一般規定</p>
      </div>
    </div>
    <!-- 參展一般規定 -->
    <div class="member_block">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 參展一般規定
      </h2>-->
    </div>
    <div class="signup_rule_block">
      <h4>參展廠商須嚴格遵守「參展一般規定」，違者經大會勸導無效，得當場停止其展出！</h4>
      <img src="@/assets/signup/rules.png" />
      <p>
        <input id="rules_check" type="checkbox" />
        <label for="rules_check" style="color:red;font-size:1.2rem;">本公司已詳閱本展之徵展企畫書且承諾遵守「參展規定」上所列各項條文，如有違反情事，本公司願負一切法律賠償責任</label>
        <br>
        <router-link id="admitBtn" :to="{name: 'sign'}" tag="button" class="submit_btn red" style="display:none;margin:20px auto;">確 認 送 出</router-link>
      </p>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  data () {
    return{}
  },
  mounted() {
    $(function(){
      $('#rules_check').on('change',() => $('#admitBtn').toggle());
    })
  }
}
</script>

<style>
.member_block>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}

.signup_rule_block > h4 {
  max-width:900px;
  color:red;
  margin:10px auto;
}
.signup_rule_block > img {
  width:100%;
  height:auto;
  margin:auto;
}
.signup_rule_block > p {
  max-width:1050px;
  margin:10px auto;
  text-align:center;
}


/* 共用設定 */
/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}

/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/rules.vue